import React from "react";
import { Filter, Search } from "lucide-react";
import ClientSearchSelect from "../../common/ClientSearchSelect";

const OrdersFilters = ({
  activeTab,                 
  client, setClient,
  clientOptions,
  fromDate, setFromDate,
  toDate, setToDate,
  search, setSearch,
  onRefresh,
}) => {
  return (
    <div className="rounded-2xl border border-gray-100 bg-white">
      <div className="flex items-center justify-between border-b px-4 py-3">
        <div className="flex items-center gap-2">
          <div className="grid h-9 w-9 place-items-center rounded-xl bg-emerald-50 text-emerald-600">
            <Filter size={16} />
          </div>
          <h3 className="text-sm font-semibold text-gray-900">Filters</h3>
        </div>
      </div>

      <div className="p-4">
        <div className="grid grid-cols-1 gap-3 md:grid-cols-4">
          <div>
            <div className="mb-1 text-xs font-medium text-gray-600">Client</div>
          <ClientSearchSelect
clients={clientOptions || []}
  value={client}
  className="w-full [&>button]:rounded-lg [&>button]:border-gray-200 [&>button]:h-[38px]"
  placeholder="All Clients"
  onChange={(selected) => {
    setClient(selected?.value || selected?.us_code || "");
  }}
/>
          </div>

          <div>
            <div className="mb-1 text-xs font-medium text-gray-600">From</div>
            <input
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              className="w-full rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm outline-none ring-emerald-200 focus:ring-2"
            />
          </div>

          <div>
            <div className="mb-1 text-xs font-medium text-gray-600">To</div>
            <input
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              className="w-full rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm outline-none ring-emerald-200 focus:ring-2"
            />
          </div>

          <div>
            <div className="mb-1 text-xs font-medium text-gray-600">Search</div>
            <div className="flex items-center gap-2 rounded-lg border border-gray-200 bg-white px-2">
              <Search size={14} className="text-gray-400" />
              <input
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Order ID / name / phone"
                className="h-9 w-full bg-transparent text-sm outline-none"
              />
            </div>
          </div>
        </div>

        <div className="mt-3 flex items-center gap-2">
          <button
            onClick={onRefresh}
            className="rounded-lg border px-3 py-1.5 text-xs font-semibold hover:bg-gray-50"
          >
            Refresh
          </button>

          <span className="text-xs text-gray-500">
            Tab: <span className="font-medium">{activeTab === "current" ? "Current Orders" : "Order History"}</span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default OrdersFilters;
